// src/components/Navbar.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthButtons from './auth/AuthButtons';
import { useAuth } from '../context/AuthContext';

  
  const Navbar = ({ showLogin, onResetSearch }) => {
  const { currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleLogoClick = (e) => {
    if (location.pathname === '/search') {
      e.preventDefault(); // Prevent default if on search page
      navigate('/'); // Navigate to home
    }
  };
  
  return (
    <nav className="bg-gray-800 border-b border-gray-700 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link 
              to="/" 
              className="flex-shrink-0 text-blue-400 font-bold text-xl"
              onClick={handleLogoClick}
            >
              bestboard.games
            </Link>
          </div>
          
          <div className="flex items-center">
            {/* Only show "Admin" if user is admin */}
            {currentUser && currentUser.is_admin === 1 && (
              <Link 
                to="/admin" 
                className={`mr-4 px-3 py-2 rounded-md text-sm font-medium ${
                  location.pathname === '/admin' 
                    ? 'text-white bg-gray-700' 
                    : 'text-gray-300 hover:text-white hover:bg-gray-700'
                }`}
              >
                Admin
              </Link>
            )}
                        
            <AuthButtons showLogin={showLogin} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;